// Helpers compartidos
import { TRIP } from "../data/trip";

export function findPlaceById(id, trip = TRIP) {
  return (trip.places || TRIP.places)[id] || null;
}

export function findFlightById(id, trip = TRIP) {
  return (trip.flights || TRIP.flights).find((f) => f.id === id) || null;
}

export function findHotelById(id, trip = TRIP) {
  return (trip.hotels || TRIP.hotels).find((h) => h.id === id) || null;
}

export function resolveStop(stopRef, trip = TRIP) {
  if (!stopRef) return null;
  const [kind, id] = stopRef.split(":");
  if (kind === "place") {
    const p = findPlaceById(id, trip);
    if (!p) return null;
    return { kind: "place", id, data: p };
  }
  if (kind === "flight") {
    const f = findFlightById(id, trip);
    if (!f) return null;
    return { kind: "flight", id, data: f };
  }
  if (kind === "hotel") {
    const h = findHotelById(id, trip);
    if (!h) return null;
    return { kind: "hotel", id, data: h };
  }
  return null;
}

export function getDayCenter(day) {
  // Promedio coords del día (para centrar mapa)
  const coords = [];
  (day.stops || []).forEach((s) => {
    const r = resolveStop(s);
    if (!r) return;
    if (r.kind === "place") coords.push([r.data.lat, r.data.lng]);
    if (r.kind === "hotel") coords.push([r.data.lat, r.data.lng]);
    if (r.kind === "flight") {
      if (r.data.from) coords.push([r.data.from.lat, r.data.from.lng]);
    }
  });
  if (!coords.length) return null;
  const lat = coords.reduce((a, c) => a + c[0], 0) / coords.length;
  const lng = coords.reduce((a, c) => a + c[1], 0) / coords.length;
  return [lat, lng];
}

export function formatDate(iso) {
  if (!iso) return "";
  // Parse manualmente para evitar conversión a TZ del browser
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  const months = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  return `${parseInt(m[3], 10)} ${months[parseInt(m[2], 10) - 1]} ${m[1]}`;
}

export function formatTime(iso) {
  if (!iso) return "";
  // Toma las horas:minutos directamente del ISO local, sin convertir TZ
  const m = String(iso).match(/T(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : "";
}

export function isDayToday(dayDate) {
  const today = new Date();
  const d = new Date(dayDate);
  return today.toDateString() === d.toDateString();
}

export function dayIndexForDate(date = new Date()) {
  const todayStr = date.toISOString().slice(0, 10);
  return TRIP.days.findIndex((d) => d.date === todayStr);
}

// Find which day(s) of the itinerary include a given place id (via stops "place:placeId").
// Returns an array of { id, date, dayLabel, city } in chronological order.
export function findDaysForPlace(placeId, trip = TRIP) {
  const days = trip.days || TRIP.days || [];
  const out = [];
  days.forEach((d) => {
    if (Array.isArray(d.stops) && d.stops.some((s) => s === `place:${placeId}`)) {
      out.push({ id: d.id, date: d.date, dayLabel: d.dayLabel, city: d.city });
    }
  });
  return out;
}


// Build a route path under the active /viaje/:tripId/ if present.
// Pages must call useTripBase() and pass the result here.
export function tripPath(base, sub = "") {
  if (!base) return "/" + sub.replace(/^\//, "");
  const clean = sub.replace(/^\//, "");
  return clean ? `${base}/${clean}` : base;
}
